import React from 'react';
import { useState } from 'react';
const ConnectorComponent = () => {
  const [authCode, setAuthCode] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [case_id, setCaseId] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const [caseName, setCaseName] = useState("");
  const [targetCaseId, setTargetCaseId] = useState("");
  
  async function auth(){
    var auth_url = "https://api2.factview.nl/connector/auth?response_type=code&client_id=9c4d0e2f3a7b481f92c51a6e34ff0b82&redirect_uri=https://importmodule.factview.nl/app?import=appconnector";
    window.location.href = auth_url;
  }

  async function getTokens(){
    var response = await fetch('https://api2.factview.nl/connector/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        grant_type: 'authorization_code',
        auth_code: authCode,
        client_id: '9c4d0e2f3a7b481f92c51a6e34ff0b82',
        client_secret: 'b1f4c3d7a82e1f6d9a7c4f59e3810b2a5d9d23cf1e87b4a6c53a72f0e5c9d48a',
      }),
    }); 
    var responseData = await response.json();
    console.log(responseData);
  }

  async function refreshAccessToken() {
    const response = await fetch('https://api2.factview.nl/connector/refresh', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        client_id: '9c4d0e2f3a7b481f92c51a6e34ff0b82',
        client_secret: 'b1f4c3d7a82e1f6d9a7c4f59e3810b2a5d9d23cf1e87b4a6c53a72f0e5c9d48a',
      }),
    });
    console.log(response);
    const data = await response.json();
    console.log(data);
    return data;
  }
  async function getCompanies(){
    var response = await fetch('https://api2.factview.nl/connector/companies', {
      method: 'GET',
      headers: {
        Authorization: 'Bearer '+accessToken,
        'Content-Type': 'application/json',
      },
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }
  async function getImportsets(){
    var response = await fetch(`https://api2.factview.nl/api/${case_id}/importsets`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer '+accessToken,
        'Content-Type': 'application/json',
      },
    }); 
    var responseData = await response.json();
  }

  async function APIEndpoint(){
    console.log(endpoint);
    var response = await fetch(endpoint, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer '+accessToken,
        // 'Content-Type': 'application/json',
      },
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }

  async function testAPI(){
    var response = await fetch('https://api2.factview.nl/api/get', {
      method: 'GET',
      headers: {
        Authorization: 'Bearer '+accessToken,
        'Content-Type': 'application/json',
      },
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }
  async function createCase(){
    var response = await fetch('https://api2.factview.nl/case/createCase', {
      method: 'POST',
      headers: {
        'Authorization': 'b7e4c1f29d83aa4fe6c2d904e13b78cd',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        case_name: "testdeletable",
        authentication_id: "12345",
      }),
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }  
  async function updateCase(){
    var response = await fetch('https://api2.factview.nl/case/updateCase', {
      method: 'POST',
      headers: {
        'Authorization': 'b7e4c1f29d83aa4fe6c2d904e13b78cd',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: caseName,
        case_id: targetCaseId,
        authentication_id: "12345",
      }),
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }  
  async function deleteCase(){
    var response = await fetch('https://api2.factview.nl/case/deleteCase', {
      method: 'POST',
      headers: {
        'Authorization': 'b7e4c1f29d83aa4fe6c2d904e13b78cd',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        case_id: targetCaseId,
        authentication_id: "12345",
      }),
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }  
  async function registerImportUser() {
    var response = await fetch('https://api2.factview.nl/connector/registerImportUser', {
      method: 'POST',
      headers: {
        'Authorization': 'b7e4c1f29d83aa4fe6c2d904e13b78cd',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        mail: 'testNew',
        naam: 'testNew',
        user_id: '12345',
      }),
    }); 

    console.log(response);
  }


  const handleChangeAuth = (e) => {
    setAuthCode(e.target.value);
  };
  const handleChangeAccess = (e) => {
    setAccessToken(e.target.value);
  };
  const handleChangeRefresh = (e) => {
    setRefreshToken(e.target.value);
  };
  const handleCaseId = (e) => {
    setCaseId(e.target.value);
  };
  const handleEndpoint = (e) => {
    setEndpoint(e.target.value);
  };
  const handleChangeName = (e) => {
    setCaseName(e.target.value);
  };
  const handleChangeCaseId = (e) => {
    setTargetCaseId(e.target.value);
  };
  return (
    <div className="">
      <div>
        <button className="import-btn hover" onClick={()=>{auth();}}>Authenticate</button>
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{getTokens();}}>Get Tokens</button>
        <input value={authCode} onChange={handleChangeAuth}/>
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{refreshAccessToken();}}>Refresh Tokens</button>
        <input value={refreshToken} onChange={handleChangeRefresh}/>
      </div>
      <div>
        <p>Access Token: </p>
        <input value={accessToken} onChange={handleChangeAccess} />
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{testAPI();}}>Test API</button> 
      </div>
       <div>
        <button className="import-btn hover" onClick={()=>{getCompanies();}}>Companies</button> 
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{getImportsets();}}>Importsets</button> 
        <input value={case_id} onChange={handleCaseId} />
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{APIEndpoint();}}>Test Endpoint</button> 
        <input value={endpoint} onChange={handleEndpoint} />
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{registerImportUser();}}>Test Register</button> 
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{createCase();}}>Create Case</button> 
      </div>
        <div>
        <p>Case ID: </p>
        <input value={targetCaseId} onChange={handleChangeCaseId} />
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{updateCase();}}>Update Case</button>
        <input value={caseName} onChange={handleChangeName} />
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{deleteCase();}}>Delete Case</button>
      </div>
    </div>
  );
};

export default ConnectorComponent;
